import im from '../../images/main.jpg'
export const homeObjOne={
    id:'About',
    lightBg:true,
    lightText:true,
    lightTextDesc:true,
    TopLine:'Chakki Aata',
    headLine:'Number 1 Quality , Number 1 Taste',
    description:'You will definitely be back for more',
    buttonLabel:'xx',
    imgStart:false,
    img : im,
    alt:'Aata',
    dark:true,
    primary:true,
    darkText:false

}

export const homeObjtwo={
    id:'About',
    lightBg:true,
    lightText:false,
    lightTextDesc:true,
    TopLine:'Chakki Aata',
    headLine:'Number 1 Quality , Number 1 Taste',
    description:'You will definitely be back for more',
    buttonLabel:'xx',
    imgStart:true,
    img : require('../../images/5kg.jpeg'),
    alt:'Aata', 
    dark:true,
    primary:true,
    darkText:true

}
export const homeObjthree={
    id:'About',
    lightBg:true,
    lightText:true,
    lightTextDesc:true,
    TopLine:'Chakki Aata',
    headLine:'Number 1 Quality , Number 1 Taste',
    description:'You will definitely be back for more',
    buttonLabel:'xx',
    imgStart:true,
    img : require('../../images/5kg.jpeg'),
    alt:'Aata', 
    dark:true,
    primary:true,
    darkText:true

}
export const homeObjfour={
    id:'About',
    lightBg:true,
    lightText:false,
    lightTextDesc:true,
    TopLine:'Chakki Aata',
    headLine:'Number 1 Quality , Number 1 Taste',
    description:'You will definitely be back for more',
    buttonLabel:'xx',
    imgStart:true,
    img : require('../../images/5kg.jpeg'),
    alt:'Aata', 
    dark:true,
    primary:true,
    darkText:true

}
export const homeObjfive={
    id:'About',
    lightBg:true,
    lightText:true,
    lightTextDesc:true,
    TopLine:'Chakki Aata',
    headLine:'Number 1 Quality , Number 1 Taste',
    description:'You will definitely be back for more',
    buttonLabel:'xx',
    imgStart:true,
    img : require('../../images/5kg.jpeg'),
    alt:'Aata', 
    dark:true,
    primary:true,
    darkText:true

}
export const homeObjsix={
    id:'About',
    lightBg:true,
    lightText:true,
    lightTextDesc:true,
    TopLine:'Chakki Aata',
    headLine:'Number 1 Quality , Number 1 Taste',
    description:'You will definitely be back for more',
    buttonLabel:'xx',
    imgStart:true,
    img : require('../../images/5kg.jpeg'),
    alt:'Aata', 
    dark:true,
    primary:true,
    darkText:true

}
export const homeObjseven={
    id:'About',
    lightBg:true,
    lightText:true,
    lightTextDesc:true,
    TopLine:'Chakki Aata',
    headLine:'Number 1 Quality , Number 1 Taste',
    description:'You will definitely be back for more',
    buttonLabel:'xx',
    imgStart:true,
    img : require('../../images/5kg.jpeg'),
    alt:'Aata', 
    dark:true,
    primary:true,
    darkText:true

}
export const homeObjeight={
    id:'About',
    lightBg:true,
    lightText:true,
    lightTextDesc:true,
    TopLine:'Chakki Aata',
    headLine:'Number 1 Quality , Number 1 Taste',
    description:'You will definitely be back for more',
    buttonLabel:'xx',
    imgStart:true,
    img : require('../../images/5kg.jpeg'),
    alt:'Aata', 
    dark:true,
    primary:true,
    darkText:true

}
export const homeObjnine={
    id:'About',
    lightBg:true,
    lightText:true,
    lightTextDesc:true,
    TopLine:'Chakki Aata',
    headLine:'Number 1 Quality , Number 1 Taste',
    description:'You will definitely be back for more',
    buttonLabel:'xx',
    imgStart:true,
    img : require('../../images/5kg.jpeg'),
    alt:'Aata', 
    dark:true,
    primary:true,
    darkText:true

}
export const homeObjten={
    id:'About',
    lightBg:true,
    lightText:true,
    lightTextDesc:true,
    TopLine:'Chakki Aata',
    headLine:'Number 1 Quality , Number 1 Taste',
    description:'You will definitely be back for more',
    buttonLabel:'xx',
    imgStart:true,
    img : require('../../images/5kg.jpeg'),
    alt:'Aata', 
    dark:true,
    primary:true,
    darkText:true

}